<template>
  <nav class="navbar navbar-expand-lg navbar-light main-nav">
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <svg width="30" height="2" viewBox="0 0 21 2" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H21V2H0V0Z" fill="white"/>
      </svg>
      <svg width="30" height="2" viewBox="0 0 21 2" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H21V2H0V0Z" fill="white"/>
      </svg>
      <svg width="30" height="2" viewBox="0 0 21 2" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 0H21V2H0V0Z" fill="white"/>
      </svg>
    </button>
    <a class="navbar-brand" href="#">
      <img src="@/assets/dashboard/img/logo.png" alt="logo">
    </a>


    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <li class="nav-item active">
          <router-link class="nav-link" to="/">Home </router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/categories">Offerings</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/gv-learning">GV Portal</router-link>
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/store">Store</router-link>
        </li>

      </ul>
      <!--<form class="form-inline my-2 my-lg-0">
        <button class="btn btn-outline-success my-2 my-sm-0 login" type="submit">Login</button>
        <button class="btn btn-outline-success my-2 my-sm-0 signup" type="submit">Sign Up</button>
      </form>-->
    </div>
  </nav>
</template>

<script>
import $ from 'jquery'

export default {
  mounted() {
    $("nav .navbar-toggler").click(function () {
      if ($("nav .collapse").hasClass("show")) {
        $("nav .collapse").slideUp(500);
        $("nav .collapse").removeClass("show");
      } else {
        $("nav .collapse").slideDown(500);
        $("nav .collapse").addClass("show");
      }
    });
  }
}
</script>


<style lang="scss" scoped>
@import "~@/assets/dashboard/styles.scss";
.main-nav {
  padding: 46px 110px;
  box-shadow: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
  width: 100%;
  button {
    @media (min-width: $width1) and (max-width: $width2) {
      display: inline-block !important;
      padding: 0;
    }
    svg {
      display: block;
      margin-bottom: 8px;
      width: 31px;
      height: 4px;
    }
  }
  @media (min-width: $width1) and (max-width: $width2) {
    padding: 36px 26px;
  }
  .navbar-brand {
    justify-content: flex-start;
    @media (min-width: $width1) and (max-width: $width2) {
      position: relative;
      left: -30%;
      top: -3px;
      width: 153px;
      height: 77px;
    }
    img {
      @media (min-width: $width1) and (max-width: $width2) {
        width: 100%;
      }
    }
  }
  .collapse {
    justify-content: flex-end;
    @media (min-width: $width1) and (max-width: $width2) {
      position: absolute;
      background-color: #003827;
      top: 126px;
      z-index: 9;
      padding: 18px 10px;
    }
    .navbar-nav {
      .nav-item {
        margin: 0 34px;
        @media (min-width: $width1) and (max-width: $width2) {
          border-bottom: 1px solid #DDD;
          padding: 8px 0;
        }
        .nav-link {
          font-family: Roboto;
          font-style: normal;
          font-weight: bold;
          font-size: 17px;
          line-height: 20px;
          color: #FFFFFF;
        }
      }
      .nav-item:last-of-type {
        @media (min-width: $width1) and (max-width: $width2) {
          border-bottom: none;
        }
      }
    }
    form {
      @media (min-width: $width1) and (max-width: $width2) {
        margin-top: 20px !important;
      }
      .login {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 17px;
        line-height: 20px;
        color: #FFFFFF;
        border: none;
        margin-right: 10px;
        border-radius: 0;
        background-color: unset;
        border-radius: 68px;
        padding: 14px 47px;
        &:hover {
          background: linear-gradient(262.11deg, #00D772 -27.45%, #003827 93.2%);
          border-color: #198754;
          box-shadow: none !important;
        }
        &:focus {
          background: linear-gradient(262.11deg, #00D772 -27.45%, #003827 93.2%);
        }
      }
      .signup {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 17px;
        line-height: 20px;
        color: #FFFFFF;
        border: none;
        margin-right: 10px;
        background: linear-gradient(262.11deg, #00D772 -27.45%, #003827 93.2%);
        border-radius: 68px;
        padding: 14px 50px;
        &:hover {
          box-shadow: none !important;
          background: linear-gradient(262.11deg, #00D772 -27.45%, #003827 93.2%);
        }
        &:focus {
          box-shadow: none !important;
        }
      }
    }
  }
}
</style>
